import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AuthInlineLinkPrompt',
  props: {
    promptText: { default: 'Already have an account?' },
    actionText: { default: 'Sign In' },
    to: { default: '/sign-in' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})